// src/Hooks/useAccessToken.ts
import { useCallback } from "react";
import { useAuth } from "../../Context/AuthContext";
import { getAccessToken as refresh } from "../../Components/Utils/TokenRefresh";

/**
 * React hook wrapper around getAccessToken().
 * Components can call   const token = await useAccessToken()();
 */
export function useAccessToken() {
  const { accessToken, setAccessToken } = useAuth();

  return useCallback(async () => {
    const tok = await refresh();
    if (tok !== accessToken) setAccessToken(tok);
    return tok;
  }, [accessToken, setAccessToken]);
}
